import { render } from "./PopupOffer.vue?vue&type=template&id=da4e1906&scoped=true"
import script from "./PopupOffer.vue?vue&type=script&lang=js"
export * from "./PopupOffer.vue?vue&type=script&lang=js"

import "./PopupOffer.vue?vue&type=style&index=0&id=da4e1906&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4e1906"]])

export default __exports__